import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';
import API from 'js/lib/api';

import CourseStoreClass from 'bundles/in-course-stores/stores/CourseStore';

export default (actionContext: ActionContext): Q.Promise<any> => {
  const api = API('/api/domains.v1', { type: 'rest' });

  if (actionContext.getStore(CourseStoreClass).domains !== undefined) {
    return Q();
  }

  return Q(api.get('?fields=id,name'))
    .then((response) => {
      actionContext.dispatch('LOAD_DOMAINS', response.elements);
    })
    .catch((error) => {
      actionContext.dispatch('LOADING_DOMAINS_ERROR', error);
    });
};
